import { createSlice, PayloadAction } from '@reduxjs/toolkit';

type User = {
  id?: string;
  name?: string;
  // keep loose to align with existing backend member shape
  [key: string]: any;
} | null;

interface AuthState {
  isAuthenticated: boolean;
  user: User;
  token: string | null;
}

const initialState: AuthState = {
  isAuthenticated: false,
  user: null,
  token: null,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    // Simple local login helper (not used by api.ts)
    login(state, action: PayloadAction<User>) {
      state.isAuthenticated = !!action.payload;
      state.user = action.payload;
    },
    // Used by api.ts: accepts { token, member }
    setCredentials(
      state,
      action: PayloadAction<{ token: string; member: any }>
    ) {
      const { token, member } = action.payload;
      state.token = token;
      state.user = member;
      state.isAuthenticated = true;
    },
    logout(state) {
      state.isAuthenticated = false;
      state.user = null;
      state.token = null;
    },
  },
});

export const { login, logout, setCredentials } = authSlice.actions;

export default authSlice.reducer;

